import { useEffect, useState } from "react";
import { AdminLayout } from "@/components/AdminLayout";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { History, Search, RefreshCw } from "lucide-react";

const actionLabel = {
  import_users: { label: "Importação de alunos", cls: "bg-blue-100 text-blue-800 border-blue-200" },
  import_certificates: { label: "Emissão de certificados", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
};

export default function AdminAuditoria() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const load = () => {
    const params = {};
    if (filter) params.action = filter;
    api.get("/admin/audit", { params }).then(r => setItems(r.data || [])).catch(() => {});
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, []);

  return (
    <AdminLayout title="Auditoria">
      <Card className="rounded-xl"><CardContent className="p-4 flex flex-wrap gap-3 items-end">
        <div className="relative flex-1 min-w-[260px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
          <Input className="pl-9" placeholder="Filtrar por ação (ex: import_users)" value={filter} onChange={(e) => setFilter(e.target.value)} onKeyDown={(e) => e.key === "Enter" && load()} data-testid="audit-search" />
        </div>
        <Button onClick={load} variant="outline"><RefreshCw className="w-4 h-4 mr-1" /> Atualizar</Button>
      </CardContent></Card>
      <Card className="rounded-xl mt-4"><CardContent className="p-0 overflow-x-auto">
        <Table><TableHeader><TableRow>
          <TableHead>Quando</TableHead><TableHead>Ação</TableHead><TableHead>Ator</TableHead><TableHead>Tipo</TableHead><TableHead>Detalhes</TableHead>
        </TableRow></TableHeader>
          <TableBody>
            {items.map(l => {
              const ai = actionLabel[l.action] || { label: l.action, cls: "" };
              return (
                <TableRow key={l.id}>
                  <TableCell className="text-xs">{l.created_at && new Date(l.created_at).toLocaleString("pt-BR")}</TableCell>
                  <TableCell><Badge className={ai.cls} variant="outline">{ai.label}</Badge></TableCell>
                  <TableCell className="text-xs">{l.actor_name || "—"}</TableCell>
                  <TableCell className="text-xs">{l.target_type || "—"}</TableCell>
                  <TableCell className="text-xs font-mono-id">{JSON.stringify(l.details || {})}</TableCell>
                </TableRow>
              );
            })}
            {items.length === 0 && <TableRow><TableCell colSpan={5} className="py-10 text-center text-sm text-muted-foreground"><History className="w-5 h-5 inline mr-2" /> Nenhum registro</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </AdminLayout>
  );
}
